import { createAndDownloadExcel, generateExcelFilename } from './excelExportUtils';
import i18n from '../i18n/i18n';

/**
 * Alarm/olay geçmiş verilerini Excel formatında indirir.
 * Dosya adı ve sheet adı sabit Türkçe değil; aktif UI diline göre belirlenir.
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {string} nodeId - Node ID
 */
export const exportAlarmHistory = (rows, columns, nodeId) => {
  const title = i18n.t('nodeComponents.alarmHistory.title', {
    defaultValue: 'Event History',
  });

  // Dosya/sheet için sorunlu karakterleri temizle; boşlukları '_' yap.
  const safeTitle = title.replace(/[\\/:*?"<>|[\]]/g, '').trim();
  const prefix = safeTitle.replace(/\s+/g, '_') || 'Event_History';
  // Excel sheet adı en fazla 31 karakter olabilir.
  const sheetName = safeTitle.slice(0, 31) || 'Event History';

  const fileName = generateExcelFilename(prefix, nodeId || 'Node');

  return createAndDownloadExcel(rows, columns, sheetName, fileName, {
    maxColumnWidth: 60, // description için daha geniş
  });
};
